import { render, staticRenderFns } from "./passRejectRefuse.vue?vue&type=template&id=51e70208&scoped=true"
import script from "./passRejectRefuse.vue?vue&type=script&lang=js"
export * from "./passRejectRefuse.vue?vue&type=script&lang=js"
import style0 from "./passRejectRefuse.vue?vue&type=style&index=0&id=51e70208&prod&scoped=true&lang=css"
import style1 from "./passRejectRefuse.vue?vue&type=style&index=1&id=51e70208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e70208",
  null
  
)

export default component.exports